var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content credit-business-manage-native" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _vm.$checkPermission(["tab_CreditManage_tabLockList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_LockTheBill"),
                        name: "tabLock",
                        lazy: true
                      }
                    },
                    [_c("tab-lock", { ref: "tabLock" })],
                    1
                  )
                : _vm._e(),
              _vm.$checkPermission(["tab_CreditManage_tabSpecialApprovalList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SpecialApproval"),
                        name: "tabSpecialApproval",
                        lazy: true
                      }
                    },
                    [_c("tab-special-approval", { ref: "tabSpecialApproval" })],
                    1
                  )
                : _vm._e(),
              _vm.$checkPermission(["tab_CreditManage_tabCreditLogList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Log"),
                        name: "tabCreditLog",
                        lazy: true
                      }
                    },
                    [_c("tab-credit-log", { ref: "tabCreditLog" })],
                    1
                  )
                : _vm._e(),
              _vm.$checkPermission(["tab_CreditManage_tabSettleAccountList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SettleAccountsTo"),
                        name: "tabCreditControl",
                        lazy: true
                      }
                    },
                    [_c("tab-credit-control", { ref: "tabCreditControl" })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }